import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import * as crypto from 'crypto-js';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { PersonalAch } from '../interface/ach-payment/payment-achrequest.interface';
import { ValidateAchRequest } from '../interface/ach-payment/validate-ach-request.interface';
import { ValidateACHResponse } from '../interface/ach-payment/validate-ach-response.interface';
import { TokenResponse } from '../interface/eCheck/token-response.interface';

/**
 *
 *
 * @export
 * @class AchService
 */
@Injectable()
export class AchService {
    constructor(private _http: Http) { }


    /**
     *
     * @date 2020-12-21
     * @param {number} memberId
     * @param {*} personalCheck
     * @returns {Observable<TokenResponse>}
     * @memberof AchService
     */
    savePersonalCheck(memberId: number, personalCheck: PersonalAch): Observable<TokenResponse> {
        const headers = this.getPaymentHeaders();
        return this._http.post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'members/' + memberId +
        '/personal-check')), personalCheck, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     *
     * @date 2020-12-21
     * @param {ValidateAchRequest} achRequest
     * @returns {Observable<ValidateACHResponse>}
     * @memberof AchService
     */
    validateAch(achRequest: ValidateAchRequest): Observable<ValidateACHResponse> {
        const headers = this.getPaymentHeaders();
        return this._http
            .post(ApiUrlConstants.paymentApiUrl + 'payments/validate-payment-check', achRequest, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     *
     * @date 2020-12-21
     * @param {number} memberId
     * @param {string} countryCode
     * @returns {Observable<IPersonalAch[]>}
     * @memberof AchService
     */
    getSavedEchecks(memberId: number, countryCode: string, checkType: string,personalCheckId?:string, verifiedEcheck?:boolean , secType?:string): Observable<PersonalAch[]> {
        const headers = this.getPaymentHeaders();
        verifiedEcheck =!!verifiedEcheck;
        let apiUrl = ApiUrlConstants.paymentApiUrl + 'members/' + memberId +
        '/personal-checks?countryCode=' + countryCode +'&checkType=' + checkType+"&verifiedCheck="+verifiedEcheck;
        if(personalCheckId) {
            apiUrl = apiUrl + '&personalCheckId=' +personalCheckId;
        }
        if(secType) {
            apiUrl = apiUrl + '&secType=' +secType;
        }
        return this._http
            .get(apiUrl, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);      
    }

    /**
     * @description this is used to get
     * payment headers
     * @date 2020-12-21
     * @returns {Headers}
     * @memberof AchService
     */
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }

    /**
     * get payment crypto hashed value
     * @date 2020-12-21
     * @returns {string}
     * @memberof AchService
     */
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }

    /**
     * To handle the obervable error response
     * @date 2020-12-21
     * @private
     * @param {(Response | any)} error
     * @returns
     * @memberof AchService
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }


     /**
     * @description To get the list of bank details
     * @date 2021-01-07
     * @param {string} countryCode
     * @returns
     * @memberof AchService
     */
    getBankDetailsByCountry(countryCode: string, paymentMethod?: string) {
        const headers = this.getPaymentHeaders();
        const apiUrl = ApiUrlConstants.paymentApiUrl + 'stores/country/' + countryCode + '/bank-details' +
        '?paymentMethod=' + paymentMethod;
        return this._http
            .get(apiUrl, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
     /**
     * Update personal Echeck
     * @param memberId
     * @param personalEcheck
     */
      updatePersonalEcheck(memberId: number, personalEcheck: PersonalAch): Observable<any> {
        const headers = this.getPaymentHeaders();
        return this._http.put(ApiUrlConstants.paymentApiUrl + 'members/' +
            memberId + '/personal-check/' + personalEcheck.id, JSON.stringify(personalEcheck),
            { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }


}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/ach.service.ts